import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AppRouter from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';
import { MAINTENANCE_MODE } from './config/config';
import Maintenance from './pages/public/Maintenance';

// Create QueryClient instance for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false, // Individual queries will override this
    },
  },
});

function App() {
  // If maintenance mode is enabled, show only the maintenance page
  if (MAINTENANCE_MODE) {
    return <Maintenance />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <div>
          <AppRouter />
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
